import React, { Component } from 'react'
import '../../resources/font-awesome/font-awesome.scss'
import g from 'glamorous'

class SocialShare extends Component {
    track_social(net)
	{
        try {
            utag.link({
                event : 'social share',
                promo_type : 'other', 
                social_network : net
            });
        } catch (errorutag) {
            
        }
	}
    render () {
        const leftInfo = this.props.leftInfo;
        const rightInfo = this.props.rightInfo;

        if(typeof window != "undefined")
        {
            var current_url = encodeURIComponent( window.location.href );
        }
        else {
            var current_url = "";
        }
        
        
        const title = ""
        const desc = "¿" + leftInfo + " vs " + rightInfo + "? Esta es otra forma, muy divertida, de ver el calendario y los grupos del Mundial de Rusia 2018"
        return (<g.Div className="social-share">
                    <g.Ul>
                        <g.Li className="share-fb" onClick={ () => { this.track_social('CalendarioRusia2018ShareFacebook'); } }>
                            <g.A className="fb" 
                                 href={
                                     "https://www.facebook.com/sharer/sharer.php?u=" + current_url + "&quote=" + encodeURIComponent(desc)
                                 } 
                                 target="_blank" 
                                 title="Facebook">
                                    <i className="fa fa-facebook fa-1x"></i>
                            </g.A>
                        </g.Li>
                        <g.Li className="share-twt" onClick={ () => { this.track_social('CalendarioRusia2018ShareTwitter'); } }>
                            <g.A className="tw" 
                                 href={
                                    "https://twitter.com/intent/tweet?source=http://www.univision.com&text=" + desc + " " + current_url
                                 } 
                                 target="_blank" 
                                 title="Twitter">
                                    <i className="fa fa-twitter fa-1x"></i>
                            </g.A>
                        </g.Li>
                        <g.Li className="share-em" onClick={ () => { this.track_social('CalendarioRusia2018ShareEmail'); } }>
                            <g.A className="email" 
                                href={
                                    "mailto:?subject=" + title + "&body=" + desc + " " + current_url
                                } 
                                title="Email">
                                    <i className="fa fa-envelope fa-1x"></i>
                            </g.A>
                        </g.Li>
                        <g.Li className="share-wp" onClick={ () => { this.track_social('CalendarioRusia2018ShareWhatsapp'); } }>
                            <g.A className="wp" 
                                 href={
                                    "whatsapp://send?text=" + desc + " " + current_url
                                 }
                                 data-action="share/whatsapp/share" 
                                 rel="nofollow" 
                                 target="_blank" 
                                 title="Whatsapp">
                                    <i className="fa fa-whatsapp fa-1x"></i>
                            </g.A>
                        </g.Li>
                    </g.Ul>
                </g.Div>)
    }
}

export default SocialShare


// WEBPACK FOOTER //
// ./src/components/calendar/social-share-fragm.js